import React from 'react'
import { Col, Row} from 'react-bootstrap';
import img from '../img/CRM BIG.jpg'
import img1 from '../img/CRM 1.jpeg'
import Image from 'react-bootstrap/Image';
import './AirExportLogisticsSoftware.css';
import './About.css';
import Sidebar from './Sidebar';

function CRM() {
  return (
    <>
        <Image className="fade-in responsive-img" src={img} height={500} width="100%" fluid />
    <div className="container my-4">
      <Row>
        <Col xs={12} md={9}>
          <h1 className='mt-5 pt-4 text-danger'>CRM</h1>
          {/* <Image className='my-2 fade-in' src={img} height={500} fluid /> */}
          <p className='fs-6 text-justify'>Catus Software is a user-friendly application which gives a helping hand to your organisation to manage data, resources, performance, and also manages all the internal task and communication for fruitful result. Its screens are designed to reduce the work load of the user and to allow the company to reduce costs.</p> 

          <Image className="my-2 fade-in" src={img1} height={500} width="100%" fluid />
        </Col>

        <Col xs={12} md={3}>
        <Sidebar/>
        </Col>
      </Row>
    </div>
    </>
  )
}

export default CRM